// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection_hero__jltx-","overlay":"HeroSection_overlay__8okw7","content":"HeroSection_content__BKJWz","ctaButton":"HeroSection_ctaButton__T8c3B"};